import {useCallback} from 'react';
import {AddToCartActionStatus} from '../../../../constants';
import {useGlobals} from '../../../../globalPropsContext';

export const useBaseAddToCartNotificationEnd = (productId: string) => {
  const {updateAddToCartStatus} = useGlobals();

  const handleNotificationEnd = useCallback(() => {
    updateAddToCartStatus(productId, AddToCartActionStatus.IDLE);
  }, [productId, updateAddToCartStatus]);

  return {handleNotificationEnd};
};
